import CommunityObject from "./CommunityObject";
import User from "./UserObject";
import Tag from "./TagObject";

export default class MediaObject extends CommunityObject {
  constructor(media) {
    super(MediaObject.name);
    this.id = Number(media.id);
    this.uuid_id = String(media.uuid_id);
    this.name = String(media.name);
    this.description = media.description !== null ? String(media.description) : "";
    this.file_size = String(media.file_size);
    if (media.contributed_by) {
      this.contributed_by = new User(media.contributed_by);
    }
    this.contributed_at = String(media.contributed_at);
    this.num_downloads = Number(media.num_downloads);
    this.is_video = Boolean(media.has_video);
    this.duration_in_seconds = Number(media.duration_in_seconds);
    this.tags = [];
    this.is_processed = Boolean(media.is_processed);
    this.privacy_level = Number(media.privacy_level);
    this.is_publishable = Boolean(media.is_publishable);
    this.signed_full_url = String(media.signed_full_url);
    this.signed_thumb_url = String(media.signed_thumb_url);
    this.approval_status = media.approval_status;
    this.rejection_reason = media.rejection_reason;

    if (media.tags) {
      media.tags.forEach(tag => {
        this.tags.push(new Tag(tag));
      });
    }
    this.validate();
  }
  static toJSON() {
    uuid_id: this.uuid_id;
    name: this.name;
    description: this.description;
    file_size: this.file_size;
    contributed_by: this.contributed_by;
    contributed_at: this.contributed_at;
    num_downloads: this.num_downloads;
    is_video: this.is_video;
    duration_in_seconds: this.duration_in_seconds;
    tags: this.tags;
    is_processed: this.is_processed;
    privacy_level: this.privacy_level;
    is_publishable: this.is_publishable;
    signed_full_url: this.signedFullUrl;
    signed_thumb_url: this.signedThumbUrl;
    approval_status: this.approval_status;
  }
}
